const IS_DEVELOPMENT: boolean = Boolean(
  process.env.REACT_APP_ENVIRONMENT === 'dev' ||
    process.env.REACT_APP_ENVIRONMENT === 'int'
);
const IS_PRODUCTION: boolean = Boolean(
  process.env.REACT_APP_ENVIRONMENT === 'prod'
);
const BASE_PATH: string = process.env.REACT_APP_BASE_PATH || '/';
const TOKEN_API_URL: string = process.env.REACT_APP_TOKEN_URL || '';
const API_ALUMNOSCURSOS: string = process.env.REACT_APP_API_ALUMNOSCURSOS || '';
const API_CURSOS: string = process.env.REACT_APP_API_CURSOS || '';
const API_JORNADA: string = process.env.REACT_APP_API_JORNADA || '';
const API_PRACTICA: string = process.env.REACT_APP_API_PRACTICA || '';
const API_SOCIEDADES: string = process.env.REACT_APP_API_SOCIEDADES || '';
const API_TIPOPRACTICA: string = process.env.REACT_APP_API_TIPOPRACTICA || '';
const API_TIPOSERVICIO: string = process.env.REACT_APP_API_TIPOSERVICIO || '';
const API_USUARIOSPERFIL: string =
  process.env.REACT_APP_API_USUARIOSPERFIL || '';
const API_VALIDARFOTO: string = process.env.REACT_APP_API_VALIDARFOTO || '';
const API_FILTROS: string = process.env.REACT_APP_API_FILTROS || '';
const APP_CLIENT_ID: string = process.env.REACT_APP_CLIENT_ID || '';
const APP_CLIENT_SECRET: string = process.env.REACT_APP_CLIENT_SECRET || '';
const APP_HEADER_PAGETITLE: string =
  process.env.REACT_APP_PAGETITLE || 'Gestión de prácticas de conducción';
const APP_VERSION_TAG : string = process.env.REACT_APP_VERSION || '';


//panel administracion
const API_GESTORESCURSOS: string = process.env.REACT_APP_API_GESTORESCURSOS|| '';
const API_FORMADORESCURSOS: string = process.env.REACT_APP_API_FORMADORESCURSOS|| '';

export {
  IS_PRODUCTION,
  IS_DEVELOPMENT,
  BASE_PATH,
  TOKEN_API_URL,
  API_ALUMNOSCURSOS,
  API_CURSOS,
  API_JORNADA,
  API_PRACTICA,
  API_SOCIEDADES,
  API_TIPOPRACTICA,
  API_TIPOSERVICIO,
  API_USUARIOSPERFIL,
  API_VALIDARFOTO,
  API_FILTROS,
  APP_CLIENT_ID,
  APP_CLIENT_SECRET,
  APP_HEADER_PAGETITLE,
  //panel administracion
  API_GESTORESCURSOS,
  API_FORMADORESCURSOS,
  APP_VERSION_TAG,
};
